<template>
  <div class="dialog-header">
    <div :class="['dialog-header-title', { 'has-modes': modes.length }]">
      <div
        v-if="modes.length"
        class="chat-mode-toggle"
        role="radiogroup"
        :aria-label="$t('chat_box.chat_mode_label')"
        :title="$t('chat_box.chat_mode_label')"
        @mousedown.stop
        @touchstart.stop
      >
        <button
          v-for="option in modes"
          :key="option.value"
          type="button"
          role="radio"
          :aria-checked="option.value === mode ? 'true' : 'false'"
          :class="['chat-mode-option', { active: option.value === mode }]"
          :title="option.hint"
          :disabled="modeDisabled"
          @touchend.prevent.stop="onModeChange(option.value)"
          @click="onModeChange(option.value)"
        >
          {{ option.label }}
        </button>
      </div>
      <h2 class="dialog-title" :title="compactTitle ? title : null">
        <img
          src="/img/icons/rs_icon.png"
          alt="Repair Icon"
          draggable="false"
          @mousedown.prevent.stop
          @dragstart.prevent.stop
          style="
            width: 1.5em;
            height: 1.5em;
            margin-bottom: 2px;
            margin-right: 15px;
          "
        /><template v-if="!compactTitle">{{ title }}</template>
      </h2>

      <b-icon
        icon="delete"
        class="action-icon"
        @mousedown.native.prevent.stop
        @touchend.native.prevent.stop="onClear"
        @dragstart.native.prevent.stop
        @click.native="onClear"
        :title="$t('chat_box.clear_local_history')"
      />
      <button
        class="close-btn"
        @mousedown.prevent.stop
        @touchend.prevent.stop="onClose"
        @dragstart.prevent.stop
        @click="onClose"
      >
        ✖
      </button>
    </div>
    <p v-if="description" class="dialog-description" :title="description">
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    // [{ value, label, hint }]; the toggle is hidden when empty.
    modes: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: '',
    },
    modeDisabled: {
      type: Boolean,
      default: false,
    },
    // Narrow window with the mode toggle: show only the icon, title as tooltip.
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    compactTitle() {
      return this.compact && this.modes.length > 0;
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onClear() {
      this.$emit('clear');
    },
    onModeChange(value) {
      if (!this.modeDisabled && value !== this.mode) {
        this.$emit('mode-change', value);
      }
    },
  },
};
</script>

<style scoped>
.chat-mode-toggle {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 3px;
  margin-right: 8px;
  font-size: 0.6em;
  font-weight: normal;
  cursor: default;
}

.chat-mode-option {
  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 12px;
  color: white;
  padding: 2px 8px;
  cursor: pointer;
  font-size: inherit;
  white-space: nowrap;
}

.chat-mode-option.active {
  background-color: white;
  color: #5b3ea5;
  font-weight: bold;
}

.chat-mode-option:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.action-icon {
  cursor: pointer;
  margin-right: 10px;
  font-size: 1.25em;
}

.action-icon:hover {
  color: #ff6b6b;
}

.dialog-header-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: inherit;
}

.dialog-description {
  font-size: 0.9em;
  font-weight: 300;
  margin-top: -5px;
  margin-bottom: -5px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  max-width: 75%;
  text-align: center;
  cursor: inherit;
}

.dialog-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #5b3ea5;
  color: white;
  padding: 10px;
  font-size: 1.2em;
  font-weight: bold;
  cursor: grab;
}

.dialog-header:active {
  cursor: grabbing;
}

.dialog-title {
  margin: 0 auto;
  text-align: center;
  flex: 1;
  cursor: inherit;
}

/* With the mode toggle in the row, shorten the title rather than wrap it. */
.has-modes .dialog-title {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-title img {
  cursor: default;
  user-select: none;
}

.close-btn {
  background-color: transparent;
  border: none;
  color: white;
  font-size: 1.5em;
  cursor: pointer;
}

.close-btn:hover {
  color: #ff6b6b;
}
</style>
